import { DatePipe, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import {
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  ModalController,
} from '@ionic/angular/standalone';
import { TtModalComponent, TtModalTitleComponent } from '@techniek-team/modal';
import { ReleaseContract } from '../contract/release.contract';

@Component({
  selector: 'app-whats-new-modal',
  templateUrl: './whats-new-modal.component.html',
  styleUrls: ['./whats-new-modal.component.scss'],
  imports: [
    TtModalComponent,
    NgOptimizedImage,
    IonCard,
    IonCardHeader,
    IonCardTitle,
    IonCardSubtitle,
    IonCardContent,
    TtModalTitleComponent,
    DatePipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WhatsNewModalComponent {
  protected readonly modalController = inject(ModalController);

  public readonly releases = input.required<ReleaseContract[]>();
}
